// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/mind-body-no-appetite.svg';

export const MindBodyNoAppetite = (props: SvgIconProps) => (
    <SvgIcon component={Svg} inheritViewBox {...props} />
);
